import { render, staticRenderFns } from "./ContributionCheckbox.vue?vue&type=template&id=40d1853a&"
import script from "./ContributionCheckbox.vue?vue&type=script&lang=ts&"
export * from "./ContributionCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports